export default {
  addUniversityAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addUniversity", payload)
      resolve()
    })
  }
}
